module.exports = __webpack_public_path__ + "static/media/bulkMinus.9e0fa7d3.svg";